import styled from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { boxPropExclusions } from '../Box/props.js';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';

var ChipWrapper = /*#__PURE__*/styled.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__ChipWrapper",
  componentId: "sc-1crekx0-0"
})(["", " display:flex;padding-top:", ";padding-bottom:", ";background:", ";outline:none;::-moz-focus-inner{border:none;}border:", " solid ", ";align-items:center;border-radius:", ";height:", ";padding-left:", ";padding-right:", ";transition:background ", ",color ", ",border ", ";transition-timing-function:", ";pointer-events:", ";&:hover,&:focus{cursor:", ";background:", ";}&:focus-visible{outline-offset:0;box-shadow:0 0 0 4px ", ";outline:2px solid ", ";}", ""], fontFamilyStyles, function (p) {
  var top = p.theme.button.web.paddings.top;
  return typeof top === 'number' ? px2rem(top) : top;
}, function (p) {
  var bottom = p.theme.button.web.paddings.bottom;
  return typeof bottom === 'number' ? px2rem(bottom) : bottom;
}, function (props) {
  return props.disabled ? props.theme.chips.web.disabled.background : props.$active ? props.$color : props.theme.chips.web.background;
}, function (props) {
  return px2rem(props.theme.chips.web.borders.width);
}, function (props) {
  return props.disabled ? props.theme.chips.web.disabled.border : props.$active ? props.$color : props.theme.chips.web.inactive.border;
}, function (props) {
  return px2rem(props.theme.chips.web.borders.radius);
}, function (props) {
  return px2rem(props.theme.chips.web.height);
}, function (props) {
  return px2rem(props.theme.chips.web.padding.horizontal);
}, function (props) {
  return px2rem(props.theme.chips.web.padding.horizontal);
}, styles.transition.timing.slower, styles.transition.timing.slower, styles.transition.timing.slower, styles.transition["function"].base, function (props) {
  return props.disabled ? 'none' : 'auto';
}, function (props) {
  return props.cursor ? props.cursor : 'pointer';
}, function (props) {
  return props.disabled ? props.theme.chips.web.disabled.background : props.$active ? props.$color : props.theme.chips.web.inactive.hover;
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
}, boxStyles);

export { ChipWrapper };
